import { gql } from '@apollo/client';
import client from './ApolloClient'; // Apollo Client setup

// GraphQL mutation for creating a category
const CREATE_CATEGORY_MUTATION = gql`
  mutation CreateCategory($name: String!) {
    createCategory(data: { name: $name }) {
      id
      name
    }
  }
`;
const UPDATE_SUB_CATEGORY_MUTATION = gql`
  mutation UpdateCategory($id: Int!, $name: String, $parentId: Int) {
    updateCategory(
      where: { id: $id }
      data: {
        name: { set: $name }
        parent: { connect: { id: $parentId } }
      }
    ) {
      id
      name
      parent {
        id
        name
      }
    }
  }
`;
// Update an existing subcategory
export const updateSubCategoryService = async (id, name, parentId) => {
  const token = localStorage.getItem('authToken');

  // Ensure IDs are integers
  const intId = parseInt(id, 10);
  const parentIdd = parentId ? parseInt(parentId, 10) : null;

  // Build the variables object for updating the subcategory
  const variables = {
    id: intId, // Subcategory ID
    name, // Name of the subcategory
    parentId: parentIdd, // Parent category ID (optional)
  };

  try {
    const response = await client.mutate({
      mutation: UPDATE_SUB_CATEGORY_MUTATION,
      variables,
      context: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    });

    return response.data.updateSubCategory; // Adjust this based on your GraphQL schema
  } catch (error) {
    console.error('Error updating subcategory:', error);
    throw error;
  }
};



const CREATE_SUB_CATEGORY_MUTATION = gql`
  mutation CreateCategory($name: String!, $parentId:Int!) {
    createCategory(
      data: {
        name: $name
        parent: { connect: { id: $parentId } }
      }
    ) {
      id
      name
      parent {
        id
        name
      }
    }
  }
`;

// GraphQL mutation for updating a category
// Define the GraphQL mutation for updating a category
const UPDATE_CATEGORY_MUTATION = gql`
  mutation UpdateCategory($id: Int!, $data: CategoryUpdateInput!) {
    updateCategory(where: { id: $id }, data: $data) {
      id
      name
      createdAt
    }
  }
`;

const UPDATE_SUBCATEGORY_MUTATION = gql`
  mutation UpdateCategory($id: Int!, $data: CategoryUpdateInput!) {
    updateCategory(where: { id: $id }, data: $data) {
      id
      name
      createdAt
    }
  }
`;

// GraphQL mutation for deleting a category
const DELETE_CATEGORY_MUTATION = gql`
  mutation deleteCategory($id: Int!) {
    deleteCategory(where: { id: $id }) {
      id
    }
  }
`;

const GET_CATEGORIES_BY_PARENT_QUERY = gql`
  query GetCategoriesByParent($parentId: Int!) {
    listCategorys(where: { parentId: { eq: $parentId } }) {
      id
      name
      createdAt
      parentId
      parent {
        id
        name
      }
    }
  }
`;


// GraphQL query to fetch categories
const GET_CATEGORIES_QUERY = gql`
  query  {
   listCategorys{
    id
      name
      createdAt
      parentId
      parent{
      name
      }
      

    }
     
  }
`;

export const filterSubCategoriesService = async (parentId) => {
  const token = localStorage.getItem('authToken');
  
  const response = await client.query({
    query: GET_CATEGORIES_QUERY,
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });

  console.log('All categories:', response.data.listCategorys);

  // Filter to get subcategories where parentId matches the provided parameter
  const subcategories = response.data.listCategorys.filter(category => category.parentId === parentId);

  console.log(`Subcategories for parentId = ${parentId}:`, subcategories);

  return subcategories;
};


export const fetchSubCategoriesService = async () => {
  const token = localStorage.getItem('authToken');
  const response = await client.query({
    query: GET_CATEGORIES_QUERY,
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });

  console.log('All categories:', response.data.listCategorys);

  // Filter to get only subcategories (where parentId is not null)
  const subcategories = response.data.listCategorys.filter(category => category.parentId !== null);

  console.log('Subcategories:', subcategories);

  return subcategories;
};

export const fetchCategoriesService = async () => {
  const token = localStorage.getItem('authToken');
  const response = await client.query({
    query: GET_CATEGORIES_QUERY,
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    fetchPolicy: 'network-only', // This tells Apollo to always make a network request
    nextFetchPolicy: 'network-only', // This ensures subsequent requests also bypass the cache
  });
  //console.log(response.data);
  const categories = response.data.listCategorys.filter(category => category.parentId == null);
  return categories;
};
// Create a new category
export const createCategoryService = async (name,parentId) => {
  const token = localStorage.getItem('authToken');
  console.log(parentId);
  const response = await client.mutate({
    mutation: CREATE_CATEGORY_MUTATION,
    variables: { name,parentId },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
  return response.data.createCategory;
};

export const createSubCategoryService = async (name, parent) => {
  const token = localStorage.getItem('authToken');
  console.log('Creating subcategory with parent ID:', parent);
  const parentId = parseInt(parent);
  
  const response = await client.mutate({
    mutation: CREATE_SUB_CATEGORY_MUTATION,
    variables: { 
      name,
      parentId:parentId,
      parent: {
        connect: { id: parentId }  // Connect to an existing role by ID
      }
       
    },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
  
  console.log('Create subcategory response:', response.data);
  return response.data.createCategory;
};

// Update an existing category
export const updateCategoryService = async (id, name) => {
  const token = localStorage.getItem('authToken');
 // Build the `data` object for updating the category
 const intId = parseInt(id);
 const data = {
  name: { set: name },  // Correct structure for StringFieldUpdateOperationsInput
};

  const response = await client.mutate({
    mutation: UPDATE_CATEGORY_MUTATION,
    variables: {
        id: intId,  // Pass the casted integer ID
        data,  // The data object containing fields to update
      },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
  return response.data.updateCategory;
};

// Update an existing subcategory
export const updateSubCategoryService1 = async (id, name,parentId) => {
  const token = localStorage.getItem('authToken');
 // Build the `data` object for updating the category
 const intId = parseInt(id);
 const parentIdd = parseInt(parentId);
 const data = {
 name
 // parentId:{set:parentIdd}  // Correct structure for StringFieldUpdateOperationsInput
};

  const response = await client.mutate({
    mutation: UPDATE_SUBCATEGORY_MUTATION,
    variables: {
        id: intId,  // Pass the casted integer ID
        data,  // The data object containing fields to update
      },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
  return response.data.updateCategory;
};

// Delete a category
export const deleteCategoryService = async (id) => {
  const token = localStorage.getItem('authToken');
  console.log(id);
  const response = await client.mutate({
    mutation: DELETE_CATEGORY_MUTATION,
    variables: { id: parseInt(id), },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
  return response.data.deleteCategory;
};
